import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
const packageConfig = require('../../../../../package.json');

type IProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

const VCopyRight = (props: IProps) => {
  const { ref, ...rest } = props;
  const getVersion = useCallback(() => {
    try {
      let result = packageConfig.version;
      return result
        .split('.')
        .slice(0, 2)
        .join('.');
    } catch (e) {
      console.error('trans version error', e);
      return '';
    }
  }, []);

  return (
    <Wrapper {...rest}>
      <div>
        Powered by <span className="company-name">ADVANCE.AI</span>
      </div>
      <div className="version">V{getVersion()}</div>
    </Wrapper>
  );
};

export default VCopyRight;

const Wrapper = styled.div`
  font-family: VFont;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  line-height: 20px;
  .company-name {
    font-family: VFont-Bold;
  }
`;
